declare var $: any;

import { TextBox } from "../components/textBox";

export class InvestmentSupport {
    static init() {
        InvestmentSupport.updateTextBoxStatus();
        $(".investment-support").on("reloaded", ".js-autosave-replace", InvestmentSupport.updateTextBoxStatus);
        $(".investment-support").on("change", "input[type=radio][name='InvestmentSupportLevel']", InvestmentSupport.updateTextBoxStatus);
    }

    static updateTextBoxStatus() {
        const $radios = $(".investment-support input[type=radio][name='InvestmentSupportLevel']");
        InvestmentSupport.toggleStatus(true);
        $radios.each(function () {
            const $el = $(this);
            if ($el.val() === "None") {
                InvestmentSupport.toggleStatus(!$el.is(":checked"));
            }
        });
    }

    static toggleStatus(isEnabled: boolean) {
        const $textBox = $("input[name='Municipality']", ".investment-support");
        $textBox.prop("disabled", !isEnabled);

        if (!isEnabled) {
            const textBox = new TextBox($textBox);
            textBox.hideValidationError();
        }
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/partials/investmentSupport.ts